// extracted by mini-css-extract-plugin
module.exports = {"empAvatar":"EmployeeProfileTitle_empAvatar__2y3rY","backButton":"EmployeeProfileTitle_backButton__BX431","backButtonArrow":"EmployeeProfileTitle_backButtonArrow__-CjAC"};